import { EnumHelper } from 'src/app/helpers/enum-helper';
import { ColumnDefinition } from './column-definition';
import { ColumnType } from './column-type';
import { SortInfos } from './sort-infos';

/**
 * Classe contenant la description du contenu d'un tableau filtré.
 */
export class AdvancedGridviewModel {
    private _columnsDefinition: ColumnDefinition[];

    /** Liste des définitions des colonnes affichées dans le tableau. */
    private _displayedColumnsDefinitions: ColumnDefinition[];

    private _workflowColumnsDefinition: ColumnDefinition[];

    /** Definition de la colonne 'Action'. */
    private _actionColumnDefinition: ColumnDefinition;

    /** Liste des noms des colonnes affichées dans le tableau */
    private _displayedColumnNames: string[];

    /** Tri appliqué au tableau de résultats par défaut. */
    private _defaultSort: SortInfos = null;

    constructor(
        columns: ColumnDefinition[],
        defaultSort: SortInfos = new SortInfos(),
        public columnActionVisible = true
    ) {
        this._actionColumnDefinition = this.getActionColumnDefinition();
        this._columnsDefinition = columns;
        this._displayedColumnNames = this._columnsDefinition
            .filter((x) => EnumHelper.areNotEquals2(ColumnType, x.type, ColumnType.WorklowStep) && x.isVisible == true)
            .sort((x, y) => x.position - y.position)
            .map((x) => x.columnName);
        this._displayedColumnsDefinitions = this._columnsDefinition
            .filter((x) => EnumHelper.areNotEquals2(ColumnType, x.type, ColumnType.WorklowStep) && x.isVisible == true)
            .sort((x, y) => x.position - y.position);

        this._workflowColumnsDefinition = this._columnsDefinition
            .filter((x) => EnumHelper.areEquals2(ColumnType, x.type, ColumnType.WorklowStep) && x.isVisible == true)
            .sort((x, y) => x.position - y.position);

        this._workflowColumnsDefinition.forEach((x) => this._displayedColumnNames.push(x.columnName));

        if (columnActionVisible === true) {
            this._displayedColumnNames.push(this._actionColumnDefinition.columnName);
        }

        this._defaultSort = defaultSort;
    }

    get columnsDefinition(): ColumnDefinition[] {
        return this._columnsDefinition;
    }

    get displayedColumnsDefinitions(): ColumnDefinition[] {
        return this._displayedColumnsDefinitions;
    }

    get actionColumnDefinition(): ColumnDefinition {
        return this._actionColumnDefinition;
    }

    get displayedColumnNames(): string[] {
        return this._displayedColumnNames;
    }

    get workflowColumnsDefinition(): ColumnDefinition[] {
        return this._workflowColumnsDefinition;
    }

    get defaultSort(): SortInfos {
        return this._defaultSort;
    }

    getActionColumnDefinition(): ColumnDefinition {
        const def = new ColumnDefinition();
        def.columnName = 'action';
        def.cell = (row: Document) => `${row['id']}`;
        return def;
    }
}
